<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { EngagingLoader, Text } from '@Shelly/shelly-design-system';
	//Stores
	import { inclusionState } from 'src/stores/features/inclusion';
	import { os } from 'src/stores/session/native-bridge';

	export let inclusionData;

	let isSuccessful = false;

	let lastStateID = -1;

	const successImageSrc = './images/engagingLoader/circle-check-thin.svg';

	const imagesSrc = [
		'./images/engagingLoader/blu-button1-device.svg',
		'./images/engagingLoader/ht-gen3.svg',
		'./images/engagingLoader/blu-motion-device.svg',
		'./images/engagingLoader/1pm-mini-gen3.svg',
		'./images/engagingLoader/shelly-plus-1.svg',
	];

	const isIOS = $os === 'IOS';

	let error;
	let progress = 0;

	$: if ($inclusionState.id !== lastStateID) {
		lastStateID = $inclusionState.id;
		progress = progress + (isIOS || inclusionData.selectVia == 'wifi_scan' ? 15 : 30);
		if (lastStateID === -1) progress = 0;
		if (progress >= 100 && !error) {
			isSuccessful = true;
		}

		if (['status', 'error'].includes($inclusionState.type)) {
			if (
				/^(noDevicesFound|cantGetDeviceInfo|cantGetDeviceStatus|cantGetDeviceSettings|cantTurnCloudOn|cantConnectToWiFi|scanTimeout|scanTimeout|deviceNotShelly|inclusionFailed|cantConnectToBluetooth|bluetoothInclusionStop|deviceLost|pairingModeRequired|authenticationError|request_digest_password_from_user)$/.test(
					$inclusionState.raw_value,
				)
			) {
				error = $inclusionState.raw_value;
				// if (import.meta.env.DEV || $user_data.test_user) {
				// 	toast.open({
				// 		type: 'danger',
				// 		title: $inclusionState.raw_value
				// 	});
				// }

				inclusionData.timeoutClear();
				inclusionData.attempts++;
				inclusionData.running = false;
				inclusionData.bluetooth.connecting = false;
				inclusionData.error = true;
				inclusionData.errorCode = 800 + $inclusionState.id;
			}
		}
	}
</script>

<div class="d-flex justify-content-center">
	<EngagingLoader
		show
		title={error ? error : $inclusionState.value}
		{progress}
		type="content"
		{isSuccessful}
		{imagesSrc}
		{successImageSrc}
		errorImageSrc=""
	>
		<svelte:fragment slot="description">
			<Text class="text-center" styleType="body-small">
				{$format('text_inclusion_loader_description', {
					default:
						'Please wait while we are adding your device to your network. This may take a few minutes.',
				})}
			</Text>

			<!-- <Text
				class="text-center text-color-muted"
				slot="description"
				styleType="body-extra-small"
			>
				{$format('text_inclusion_loader_sub_text', {
					default:
						'please do not close the app or turn off your device.'
				})}
			</Text> -->
		</svelte:fragment>
	</EngagingLoader>
</div>
